import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { CommercialImpacts } from '../../../viewmodels/commercial-impacts/commercial-impacts';
import { CommercialImpactItemType, CommercialImpactsService } from '../commercial-impacts.service';

@Component({
  selector: 'hb-commercial-impacts',
  templateUrl: './commercial-impacts.component.html',
  styleUrls: ['./commercial-impacts.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class CommercialImpactsComponent implements OnInit {
  @Input() form: NgForm;
  @Input() totalHeader: string;
  @Input() isReadOnly: boolean;
  private _impacts: CommercialImpacts;

  @Input() set impacts(value: CommercialImpacts) {
    this.commercialImpactsService.setItem(value);
    this._impacts = value;
  }

  get impacts(): CommercialImpacts {
    return this.commercialImpactsService.getItem();
  }

  get commercialImpactItemType() {
    return CommercialImpactItemType;
  }

  constructor(private commercialImpactsService: CommercialImpactsService) {}

  ngOnInit() {}

  calculateCurrentTotal(): number {
    return this.commercialImpactsService.calculateCurrentTotal(this.commercialImpactsService.commercialImpacts.value);
  }
}
